(function () {
  function formatMoney(cents, symbol) {
    var amount = (cents / 100).toFixed(2);
    if (symbol === '$') {
      return symbol + amount;
    }
    return amount + symbol;
  }

  function formatMoneyFloor(cents, symbol) {
    var amount = (Math.floor(cents) / 100).toFixed(2);
    if (symbol === '$') {
      return symbol + amount;
    }
    return amount + symbol;
  }

  function parseMoney(value) {
    if (!value) {
      return null;
    }

    var normalized = String(value).replace(/[^\d.,-]/g, '').replace(/,/g, '');
    var amount = parseFloat(normalized);

    if (isNaN(amount)) {
      return null;
    }

    return Math.round(amount * 100);
  }

  function initMediaGallery(root) {
    if (!root || typeof Swiper === 'undefined') {
      return;
    }

    var mediaWrap = root.querySelector('[data-lp-buybox-media]');
    var sectionId = root.getAttribute('data-lp-buybox') || '';
    var mainEl = mediaWrap && mediaWrap.querySelector('.lp-buybox__gallery-main' + sectionId);

    if (!mainEl || mainEl.dataset.galleryReady === 'true') {
      return;
    }
    mainEl.dataset.galleryReady = 'true';

    var thumbsEl = mediaWrap.querySelector('.lp-buybox__gallery-thumbs' + sectionId);
    var prevBtn = mediaWrap.querySelector('[data-lp-gallery-prev]');
    var nextBtn = mediaWrap.querySelector('[data-lp-gallery-next]');
    var thumbsSwiper = null;

    if (thumbsEl) {
      thumbsSwiper = new Swiper(thumbsEl, {
        spaceBetween: 12,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true
      });
    }

    new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      speed: 600,
      loop: false,
      observer: true,
      observeParents: true,
      navigation: prevBtn && nextBtn ? {
        prevEl: prevBtn,
        nextEl: nextBtn
      } : undefined,
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined
    });
  }

  function ensureSwiper(root, callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    var swiperSrc = root.getAttribute('data-swiper-src');
    if (!swiperSrc) {
      return;
    }

    var existingScript = document.querySelector('script[data-swiper-lp-buybox]');

    if (existingScript) {
      existingScript.addEventListener('load', callback, { once: true });
      return;
    }

    var swiperScript = document.createElement('script');
    swiperScript.src = swiperSrc;
    swiperScript.dataset.swiperLpBuybox = 'true';
    swiperScript.onload = callback;
    document.head.appendChild(swiperScript);
  }

  function initBuybox(root) {
    if (!root || root.dataset.buyboxReady === 'true') {
      return;
    }
    root.dataset.buyboxReady = 'true';

    var configEl = root.querySelector('[data-lp-buybox-config]');
    if (!configEl) {
      return;
    }

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (error) {
      console.error('[lp-buybox] Invalid config JSON', error);
      return;
    }

    var symbol = config.currencySymbol || '$';
    var size = config.defaultSize || 'small';
    var pType = 'sub';
    var qty = null;

    var tabs = root.querySelectorAll('[data-lp-tab]');
    var panels = root.querySelectorAll('[data-lp-panel]');
    var sizeBtns = root.querySelectorAll('[data-lp-size]');
    var ptypeBtns = root.querySelectorAll('[data-lp-ptype]');
    var tiles = root.querySelectorAll('[data-lp-tile]');
    var submitBtn = root.querySelector('[data-lp-submit]');
    var submitLabel = root.querySelector('[data-lp-submit-label]');
    var perdayEl = root.querySelector('[data-lp-perday]');

    function getAllowedQtys(sizeKey) {
      var map = config.qtyBySize || {};
      return map[sizeKey] || [];
    }

    function getChews(sizeKey) {
      var map = config.chewsPerSize || {};
      return map[sizeKey] || 1;
    }

    function getSupply(sizeKey, quantity) {
      return (config.supplies || []).find(function (item) {
        return item.sizeKey === sizeKey && item.qty === quantity;
      });
    }

    function getButtonLabel(available) {
      return available ? (config.addToCartLabel || 'Add to Cart') : (config.soldOutLabel || 'Sold out');
    }

    function calcSavePercent(price, compare) {
      if (!compare || compare <= price) {
        return '';
      }
      return Math.round((1 - price / compare) * 100) + '%';
    }

    function daysFor(quantity) {
      return quantity * 60 / getChews(size);
    }

    function renderBuy() {
      var allowed = getAllowedQtys(size);
      if (allowed.indexOf(qty) === -1) {
        qty = allowed[0] || null;
      }

      sizeBtns.forEach(function (btn) {
        var key = btn.getAttribute('data-lp-size');
        btn.classList.toggle('is-active', key === size);
      });

      ptypeBtns.forEach(function (btn) {
        var key = btn.getAttribute('data-lp-ptype');
        btn.classList.toggle('is-active', key === pType);
      });

      var isSub = pType === 'sub';

      root.classList.toggle('lp-buybox--once', !isSub);

      var selectedTile = null;

      tiles.forEach(function (tile) {
        var tileQty = parseInt(tile.getAttribute('data-qty'), 10);
        var tileSize = tile.getAttribute('data-size');
        var allowedForSize = getAllowedQtys(tileSize).indexOf(tileQty) !== -1;
        var visible = tileSize === size && allowedForSize;
        tile.hidden = !visible;
        if (!visible) {
          return;
        }

        var supply = getSupply(tileSize, tileQty);
        var priceCents = supply ? (isSub ? supply.subPrice : supply.oncePrice) : 0;
        var compareCents = supply ? supply.comparePrice : 0;
        var saveTxt = calcSavePercent(priceCents, compareCents);
        var days = daysFor(tileQty);
        var isActive = tileQty === qty;

        tile.classList.toggle('is-active', isActive);

        if (isActive) {
          selectedTile = tile;
        }

        var titleEl = tile.querySelector('[data-title]');
        var sublineEl = tile.querySelector('[data-subline]');
        var priceEl = tile.querySelector('[data-price]');
        var strikeEl = tile.querySelector('[data-strike]');
        var saveEl = tile.querySelector('[data-save]');

        if (titleEl) {
          titleEl.textContent = tileQty + ' Canister' + (tileQty > 1 ? 's' : '') + ': ' + Math.round(days) + ' day supply';
        }
        if (sublineEl) {
          sublineEl.textContent = isSub
            ? '(Shipped and billed every ' + Math.round(days) + ' days)'
            : (config.onceSubline || '(One-time purchase — ships once)');
        }
        var customPrice = isSub ? tile.getAttribute('data-custom-price') : null;
        var customStrike = isSub ? tile.getAttribute('data-custom-strike') : null;
        var customSave = isSub ? tile.getAttribute('data-custom-save') : null;

        if (priceEl) {
          priceEl.textContent = customPrice || formatMoney(priceCents, symbol);
        }
        if (strikeEl) {
          if (customStrike) {
            strikeEl.textContent = customStrike;
            strikeEl.hidden = false;
          } else if (saveTxt) {
            strikeEl.textContent = formatMoney(compareCents, symbol);
            strikeEl.hidden = false;
          } else {
            strikeEl.hidden = true;
          }
        }
        if (saveEl) {
          if (customSave) {
            saveEl.textContent = customSave;
            saveEl.hidden = false;
          } else if (saveTxt) {
            saveEl.textContent = (config.savePrefix || 'SAVE ') + ' ' + saveTxt;
            saveEl.hidden = false;
          } else {
            saveEl.hidden = true;
          }
        }
      });

      var selected = getSupply(size, qty);
      var selectedCustomPrice = isSub && selectedTile
        ? (selectedTile.getAttribute('data-custom-price') || '').trim()
        : '';

      if (perdayEl && selected) {
        var selectedDays = daysFor(qty);
        var selectedPriceCents = isSub ? selected.subPrice : selected.oncePrice;
        var customPriceCents = selectedCustomPrice ? parseMoney(selectedCustomPrice) : null;
        var perDayCents = selectedDays > 0
          ? (customPriceCents !== null ? customPriceCents : selectedPriceCents) / selectedDays
          : 0;
        perdayEl.textContent = (config.perDayPrefix || 'Only ') +' '+ formatMoneyFloor(perDayCents, symbol) +' '+ (config.perDaySuffix || ' per day');
      }

      if (submitBtn) {
        submitBtn.disabled = !selected || !selected.available;
      }
      if (submitLabel && selected) {
        var label = getButtonLabel(selected.available);
        if (selectedCustomPrice) {
          submitLabel.textContent = label + ' · ' + selectedCustomPrice;
        } else {
          var price = isSub ? selected.subPrice : selected.oncePrice;
          submitLabel.textContent = label + ' · ' + formatMoney(price, symbol);
        }
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-lp-tab');
        tabs.forEach(function (item) {
          item.classList.toggle('is-active', item === tab);
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-lp-panel') !== key;
        });
      });
    });

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        size = btn.getAttribute('data-lp-size');
        qty = getAllowedQtys(size)[0] || null;
        renderBuy();
      });
    });

    ptypeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        pType = btn.getAttribute('data-lp-ptype');
        renderBuy();
      });
    });

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        qty = parseInt(tile.getAttribute('data-qty'), 10);
        renderBuy();
      });
    });

    root.querySelectorAll('[data-lp-faq]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('[data-lp-faq-row]');
        var answer = row && row.querySelector('[data-lp-faq-answer]');
        if (!answer) {
          return;
        }
        var open = row.classList.contains('is-open');
        row.classList.toggle('is-open', !open);
        answer.hidden = open;
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    if (submitBtn) {
      submitBtn.addEventListener('click', async function () {
        var selected = getSupply(size, qty);
        if (!selected || !selected.available || !selected.variantId) {
          return;
        }

        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');

        try {
          var formData = new FormData();
          formData.append('id', selected.variantId);
          formData.append('quantity', '1');
          if (pType === 'sub' && selected.sellingPlanId) {
            formData.append('selling_plan', selected.sellingPlanId);
          }

          if (config.lineItemProperty && config.lineItemProperty.enabled) {
            var propName = (config.lineItemProperty.name || '').trim();
            var propValue = (config.lineItemProperty.value || '').trim();
            if (propName && propValue) {
              formData.append('properties[' + propName + ']', propValue);
            }
          }

          var response = await fetch((window.themeVariables && window.themeVariables.routes.cartAddUrl || '/cart/add') + '.js', {
            method: 'POST',
            body: formData,
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          if (response.ok) {
            if (config.redirectToCheckout) {
              window.location.href = config.checkoutUrl || '/checkout';
              return;
            } else {
              window.location.href = '/cart';
              return;
            }

            /*if (config.addedLabel) {
              var previousLabel = submitLabel ? submitLabel.textContent : '';
              submitBtn.classList.add('is-success');
              if (submitLabel) {
                submitLabel.textContent = config.addedLabel;
              }
              setTimeout(function () {
                submitBtn.classList.remove('is-success');
                if (submitLabel) {
                  submitLabel.textContent = previousLabel;
                }
                renderBuy();
              }, 1800);
              return;
            }*/

            
          }
        } catch (error) {
          console.error('[lp-buybox] Add to cart failed', error);
        } finally {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
          renderBuy();
        }
      });
    }

    renderBuy();
  }

  function bootBuybox(root) {
    initBuybox(root);

    var mediaWrap = root.querySelector('[data-lp-buybox-media]');
    var sectionId = root.getAttribute('data-lp-buybox') || '';
    if (!mediaWrap || !mediaWrap.querySelector('.lp-buybox__gallery-main' + sectionId)) {
      return;
    }

    ensureSwiper(root, function () {
      initMediaGallery(root);
    });
  }

  function boot() {
    document.querySelectorAll('[data-lp-buybox]').forEach(bootBuybox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-lp-buybox]');
    if (!root) {
      return;
    }

    root.dataset.buyboxReady = 'false';

    var sectionId = root.getAttribute('data-lp-buybox') || '';
    var mainEl = root.querySelector('.lp-buybox__gallery-main' + sectionId);
    if (mainEl) {
      mainEl.dataset.galleryReady = 'false';
    }

    bootBuybox(root);
  });
})();
